<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->

@if (projects?.length) {
    @if (isTableViewTypeSelected()) {
        <div class="grid table-striped sui-e2e-projects-content">
            <!-- HEADER -->
            <div class="grid-row">
                <div
                        class="grid-row__cell sort-cell"
                        (click)="changeSort('name')"
                        (keydown)="changeSort('name')"
                        [ngClass]="{ 'sort-cell--active': sortParam === 'name' }"
                >
                    <span translate="project.name"></span>
                    <button windeActionIcon>
                        <sui-svg-icon [icon]="sortDescending ? 'angle-up' : 'angle-down'" windeGrey/>
                    </button>
                </div>
                <div
                        class="grid-row__cell sort-cell"
                        (click)="changeSort('nodesCount')"
                        (keydown)="changeSort('nodesCount')"
                        [ngClass]="{ 'sort-cell--active': sortParam === 'nodesCount' }"
                >
                    <span translate="project.nodesCount"></span>
                    <button windeActionIcon>
                        <sui-svg-icon [icon]="sortDescending ? 'angle-up' : 'angle-down'" windeGrey/>
                    </button>
                </div>
                <div
                        class="grid-row__cell sort-cell last-edited-by"
                        (click)="changeSort('lastEditDescription')"
                        (keydown)="changeSort('lastEditDescription')"
                        [ngClass]="{ 'sort-cell--active': sortParam === 'lastEditDescription' }"
                >
                    <span translate="project.lastEditedBy"></span>
                    <button windeActionIcon>
                        <sui-svg-icon [icon]="sortDescending ? 'angle-up' : 'angle-down'" windeGrey/>
                    </button>
                </div>
                <div
                        class="grid-row__cell sort-cell last-edited-date"
                        (click)="changeSort('lastEditDate')"
                        (keydown)="changeSort('lastEditDate')"
                        [ngClass]="{ 'sort-cell--active': sortParam === 'lastEditDate' }"
                >
                    <span translate="project.lastEditedDate"></span>
                    <button windeActionIcon>
                        <sui-svg-icon [icon]="sortDescending ? 'angle-up' : 'angle-down'" windeGrey/>
                    </button>
                </div>
                <div class="grid-row__cell"></div>
            </div>

            <!-- BODY -->
            @for (project of projects; track project.id) {
                <div
                        class="grid-row project-row project-item"
                        [draggable]="!project.bugReport && (isDragAllowed | async)"
                        (dragstart)="projectDragAndDropService.dragStart(project)"
                >
                    <div class="grid-row__cell name" (dblclick)="viewProject(project)">
                        <winde-highlight-text [text]="project.name" [searchSubstring]="searchFilter()"></winde-highlight-text>
                    </div>
                    <div class="grid-row__cell" draggable="false">{{ project.nodesCount }}</div>
                    <div class="grid-row__cell last-edited-by" draggable="false">{{ project.lastEditDescription }}</div>
                    <div class="grid-row__cell last-edited-date" draggable="false">
                        <winde-date-format [date]="project.lastEditDate" [showTimeAgo]="true" [showHours]="true"></winde-date-format>
                    </div>
                    <div class="grid-row__cell text-right text-nowrap" draggable="false">
                        <winde-project-control-btns
                                [project]="project"
                                [controlsClass]="'project-controls--row'"
                                [searchFilter]="searchFilter()"
                        >
                        </winde-project-control-btns>
                    </div>
                </div>
            }
        </div>
    } @else {
        <div class="card-deck sui-e2e-projects-content">
            @for (project of projects; track project.id) {
                <div>
                    <div
                            class="card project-item"
                            style="width: 13rem; margin: 15px"
                            [draggable]="!project.bugReport && (isDragAllowed | async)"
                            (dblclick)="viewProject(project)"
                            (dragstart)="projectDragAndDropService.dragStart(project)"
                    >
                        <img class="card-img-top" draggable="false" src="/api/projects/{{ project.id }}/preview" alt="Card cap"/>
                        <div class="card-block" draggable="false">
                            <h4
                                    class="card-title project-item__title"
                                    suiTooltip
                                    [showDelay]="2000"
                                    [disabled]="tooltipsAreDisabled"
                                    tooltipText="{{ project.name }}"
                            >
                                <winde-highlight-text [text]="project.name" [searchSubstring]="searchFilter()"></winde-highlight-text>
                            </h4>
                            <p class="card-text">
                                <span class="font-weight-normal card-text__title">Locations count:</span>
                                {{ project.nodesCount ? project.nodesCount : 0 }}
                            </p>
                            @if (project.lastEditDate) {
                                <p class="card-last-view">
                                    <span class="d-block font-weight-normal card-last-view__title">Last edited by:</span>
                                    <span class="d-block card-last-view__date">{{ project.lastEditDescription }}</span>
                                    <span class="d-block card-last-view__date">
                                        <winde-date-format [date]="project.lastEditDate" [showTimeAgo]="true" [showHours]="true">
                                        </winde-date-format>
                                    </span>
                                </p>
                            }
                            <div class="pull-right">
                                <winde-project-control-btns
                                        [project]="project"
                                        [controlsClass]="'project-controls--card'"
                                        [searchFilter]="searchFilter()"
                                >
                                </winde-project-control-btns>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    }
} @else {
    <div class="d-flex justify-content-center align-items-center empty-project">
        <strong><span>{{ 'project.home.projectsNotFound' | translate }}</span></strong>
    </div>
}
